// extracted by mini-css-extract-plugin
export default {"column":"Notifications_column__QSatY"};